const merge = (obj1, obj2) => {
  for (const key in obj1) {
    if (obj1[key] && obj2[key] && typeof obj1[key] === 'object' && !Array.isArray(obj1[key])) {
      merge(obj1[key], obj2[key]);
    }
    else {
      obj1[key] = obj2[key] == null || obj2[key] === '' ? obj1[key] : obj2[key];
    }
  }
};

const useObjectHelpers = () => {
  return {
    merge,
  };
};

export default useObjectHelpers;
